module.exports = __webpack_public_path__ + "img/huisje.b34e2b4c8876c5544ecedf916726409e.svg";